// extracted by mini-css-extract-plugin
export default {"notificationsTab":"NotificationsTab_notificationsTab__Ayid0","notificationsContent":"NotificationsTab_notificationsContent__d4699"};